export default "__VITE_ASSET__37acbf9d__"